exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-06103850]:after,.wrapper[data-v-06103850]:before{display:table;content:\" \"}.wrapper[data-v-06103850]:after{clear:both}.wrapper[data-v-06103850]{display:table;overflow-x:hidden;width:100%;max-width:100%;table-layout:fixed}.left-aside[data-v-06103850],.right-aside[data-v-06103850]{padding:0;display:table-cell;vertical-align:top}.right-aside[data-v-06103850]{background-color:#ebf2f6!important}@media (max-width:992px){.wrapper>.right-aside[data-v-06103850]{width:100vw;min-width:100vw}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06103850","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=4!./src/App.vue
// module id = eXaq
// module chunks = 1